module.exports = __webpack_public_path__ + "static/media/my-maps.c89d1e40.svg";